/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-17
 * @brief EHP Login-아이디 찾기 레이어 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useAsync } from "react-async";
import { useRecoilValue } from "recoil";
// recoil
import { getApiLangState } from "../../recoil/langState";
import $ from "jquery";
// utils
import { useTrans } from "../../utils/langs/useTrans";
import * as HttpUtil from "../../utils/api/HttpUtil";
import clog from "../../utils/logUtils";
/**
 * @brief EHP 아이디 찾기 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function FindId(props) {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    //
    const isRunYn = props.isRunYn;
    const layerList = props.layerList;
    const [isFindId, setIsFindId] = useState(isRunYn); // false
    const [userName, setUserName] = useState(""); //bsKim
    const [userPhone, setUserPhone] = useState(""); //01000000001
    const [userId, setUserId] = useState("");
    const [resErrorCode, setresErrorCode] = useState(200);
    const [resErrorMsg, setResErrorMsg] = useState([{ "field": "", "msg": "" }]);
    const [resUserNameMsg, setUserNameMsg] = useState("");
    const [resPhoneNumberMsg, setPhoneNumberMsg] = useState("");
    //20220824 추가
    const [errorList, setErrorList] = useState([]);
    const t = useTrans();
    // useAsync call axios
    const { data: data, error, isLoading, reload, run } = useAsync({
        //promiseFn: HttpUtil.getUsers,
        deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: "/api/v2/user/id",
        appQuery: {
            userName: userName,
            phoneNumber: userPhone,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            clog(isFindId);
            if (data.codeNum == 200) {
                setresErrorCode(data.codeNum);
                setUserNameMsg("아이디 찾기를 완료하였습니다");
                setUserId(data.body.userId);
                setIsFindId(true);
            }
            else {
                setresErrorCode(data.codeNum);
                setResErrorMsg(data.errorList);
                setUserNameMsg("");
                setPhoneNumberMsg("");
                //20220824 추가
                setErrorList(data.errorList);
                /* data.errorList.map((errMsg) => {
                  (errMsg.field === "userName") && setUserNameMsg(errMsg.msg);
                  (errMsg.field === "phoneNumber") && setPhoneNumberMsg(errMsg.msg);
                }); */
            }
        }
    }, [data]);
    function onClickCancel(e) {
        setresErrorCode(200);
        setIsFindId(false);
        setUserName("");
        setUserPhone("");
        //20220824 추가
        setErrorList([]);
        setUserNameMsg("");
        setPhoneNumberMsg("");
    }
    function layerClose(tagId) {
        var othLayer = tagId;
        //닫기 버튼 , 배경 클릭 시
        $("#" + othLayer)
            .children()
            .children(".js-close")
            .trigger("click", function (ee) {
            $("#" + othLayer).addClass("hidden"); //모든 팝업 감추기
            $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
        });
        //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
        $("#" + othLayer + ".layer-out")
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $(".dimm").stop().hide().css("z-index", "11");
        });
    }
    function layerOpen(e) {
        e.preventDefault();
        var actTag = (e.target.tagName == "BUTTON") ? e.target : e.currentTarget;
        var activeLayer = actTag.getAttribute("data-pop");
        //
        layerList.map((olayer) => {
            layerClose(olayer);
        });
        // 레이어 팝업 화면 가운데 정렬
        $("#" + activeLayer + ".popup-layer").css("position", "absolute");
        $("#" + activeLayer + ".popup-layer").css("top", ($(window).height() - $("#" + activeLayer).outerHeight()) / 2 + $(window).scrollTop() + "px");
        $("#" + activeLayer + ".popup-layer").css("left", ($(window).width() - $("#" + activeLayer).outerWidth()) / 2 + $(window).scrollLeft() + "px");
        // $(".popup-layer").addClass("hidden"); //모든 팝업 감추기(팝업안에 팝업이 또 있을때는 해당 안됨)
        $("#" + activeLayer).removeClass("hidden"); //호출한 팝업만 부르기
        $(".dimm").stop().show().css("z-index", "30"); //배경 가져오기
        $("body").css("overflow-y", "hidden"); //body 스크롤 숨기기(화면고정)
        //닫기 버튼 , 배경 클릭 시
        $("#" + activeLayer)
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $("#" + activeLayer).addClass("hidden"); //모든 팝업 감추기
            $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
        });
        //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
        $("#" + activeLayer + ".layer-out")
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $(".dimm").stop().hide().css("z-index", "11");
        });
    }
    // ========================================     20220824 수정  ========================================
    function handleSetUserName(val) {
        setErrorList(errorList.filter((err) => (err.field !== "userName")));
        setUserName(val);
    }
    function handleSetPhoneNumber(val) {
        setErrorList(errorList.filter((err) => (err.field !== "phoneNumber")));
        setUserPhone(val);
    }
    ;
    // ========================================     20220824 end   ========================================
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "findId", className: "popup-layer js-layer layer-out hidden login__popup" },
            " ",
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uC544\uC774\uB514 \uCC3E\uAE30"),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => onClickCancel(e) },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                (!isFindId) &&
                    React.createElement("form", { action: "", method: "", name: "popfindId" },
                        React.createElement("ul", { className: "form__input" },
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "username", className: "star" }, "\uC774\uB984"),
                                React.createElement("div", { className: "input__area" },
                                    " ",
                                    React.createElement("input", { type: "text", id: "username", placeholder: "\uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694", value: userName, className: (errorList.filter(err => (err.field === "userName")).length > 0) ? "input-error" : "", 
                                        //className={((resErrorCode == 200) && (userName.length >= 0)) || ((resErrorCode != 200) && (userName.length > 0)) ? "" : "input-error"}
                                        onChange: (e) => handleSetUserName(e.target.value) }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "userName")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userphone", className: "star" }, "\uC5F0\uB77D\uCC98"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "tel", id: "userphone", placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694", value: userPhone, className: (errorList.filter(err => (err.field === "phoneNumber")).length > 0) ? "input-error" : "", onChange: (e) => handleSetPhoneNumber(e.target.value) }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "phoneNumber")).map((err) => err.msg)))))),
                (isFindId) &&
                    React.createElement("div", { className: "complete-txt" },
                        " ",
                        React.createElement("p", { className: "tit" }, resUserNameMsg),
                        React.createElement("p", null, userId))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "js-close bg-gray", onClick: (e) => onClickCancel(e) },
                    React.createElement("span", null, "\uCDE8\uC18C")),
                (!isFindId) && React.createElement("button", { type: "button", onClick: run },
                    React.createElement("span", null, "\uCC3E\uAE30")),
                (isFindId) && React.createElement("button", { type: "button", className: "js-open", "data-pop": "findPw", onClick: (e) => layerOpen(e) },
                    React.createElement("span", null, "\uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30"))))));
}
export default FindId;
